import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaDice } from 'react-icons/fa6';
import { SITE, TRUST_LINKS, NATIONAL_GAMBLING_HELPLINE, NATIONAL_GAMBLING_HELPLINE_TEL } from '../data/site';
import PrivacyModal from './privacymodal';
import CookieModal from './cookiemodal';
import ContactModal from './contactmodal';
import './footer.css';

export default function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [cookieOpen, setCookieOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <>
      <footer className="site-footer">
        <div className="container">
          <div className="site-footer__top">
            <div className="site-footer__brand">
              <div className="site-footer__logo">
                <span className="site-footer__logo-icon" aria-hidden="true">
                  <FaDice size={20} />
                </span>
                <span className="site-footer__logo-text">{SITE.name}</span>
              </div>
              <p className="site-footer__brand-desc">
                Independent UK casino comparison portal. We review, rate, and rank UKGC-licensed casino sites so you can play with confidence.
              </p>
              <div className="site-footer__age">
                <span className="site-footer__age-circle">18+</span>
                <span>Gambling is only permitted for those aged 18 and over.</span>
              </div>
            </div>

            <div className="site-footer__col">
              <h3 className="site-footer__col-title">Casino Reviews</h3>
              <ul className="site-footer__links">
                <li><Link to="/welcome-bonuses">Welcome Bonuses</Link></li>
                <li><Link to="/new-casino-sites">New Casino Sites</Link></li>
                <li><Link to="/">All Casino Reviews</Link></li>
              </ul>
            </div>

            <div className="site-footer__col">
              <h3 className="site-footer__col-title">Guides</h3>
              <ul className="site-footer__links">
                <li><Link to="/how-it-works">How It Works</Link></li>
                <li><Link to="/responsible-gambling">Responsible Gambling</Link></li>
                <li><button className="site-footer__link-btn" onClick={() => setContactOpen(true)}>Contact Us</button></li>
              </ul>
            </div>

            <div className="site-footer__col">
              <h3 className="site-footer__col-title">Legal &amp; Safety</h3>
              <ul className="site-footer__links">
                <li><Link to="/responsible-gambling">Responsible Gambling</Link></li>
                <li><button className="site-footer__link-btn" onClick={() => setPrivacyOpen(true)}>Privacy Policy</button></li>
                <li><button className="site-footer__link-btn" onClick={() => setCookieOpen(true)}>Cookie Policy</button></li>
                <li><button className="site-footer__link-btn" onClick={() => setContactOpen(true)}>Contact</button></li>
              </ul>
            </div>
          </div>

          <div className="site-footer__notices" role="region" aria-labelledby="footer-notices-title">
            <h3 id="footer-notices-title" className="site-footer__notices-title">Age limits, risk &amp; help</h3>
            <p className="site-footer__notice-p">
              <strong>18+ only.</strong> Under UK law you must be aged 18 or over to gamble with licensed operators in Great Britain. This site is aimed at adults; we do not target or encourage anyone under 18 to gamble.
            </p>
            <p className="site-footer__notice-p">
              <strong>Gambling involves risk.</strong> You can lose money. Casino games and sports betting are not a source of income or a way to recover debts. Never chase losses or borrow money to gamble.
            </p>
            <p className="site-footer__notice-p">
              <strong>Problem gambling support (free &amp; confidential):</strong>{' '}
              National Gambling Helpline{' '}
              <a href={NATIONAL_GAMBLING_HELPLINE_TEL}>{NATIONAL_GAMBLING_HELPLINE}</a>
              {' '}(24/7). For self-exclusion across UK sites, register with{' '}
              <a href="https://www.gamstop.co.uk/" target="_blank" rel="noopener noreferrer nofollow">GAMSTOP</a>.
              Information and counselling:{' '}
              <a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer nofollow">GamCare</a>
              {' · '}
              <a href="https://www.begambleaware.org/" target="_blank" rel="noopener noreferrer nofollow">BeGambleAware</a>.
            </p>
            <p className="site-footer__notice-p site-footer__notice-p--muted">
              {SITE.name} does not operate gambling services and does not take bets. We publish comparisons and links to third-party licensed operators. Always read each operator’s terms, safer gambling tools, and eligibility rules before you play.
            </p>
          </div>

          <div className="site-footer__trust">
            <p className="site-footer__trust-title">Safer Gambling Resources</p>
            <div className="site-footer__trust-logos">
              {TRUST_LINKS.map((t) => (
                <a
                  key={t.name}
                  href={t.url}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="site-footer__trust-item"
                  title={t.description}
                >
                  <span className="site-footer__trust-logo-wrap">
                    <img src={t.logo} alt="" className="site-footer__trust-logo" />
                  </span>
                </a>
              ))}
            </div>
          </div>

          <div className="site-footer__legal">
            <p>
              {SITE.name} is an affiliate comparison website. We earn commission when you click our links and sign up at a casino. This does not affect our editorial independence. All casinos listed are licensed by the UK Gambling Commission. Gambling involves risk — please play responsibly. Commercial content — 18+ only.
            </p>
            <p className="site-footer__legal--small">
              © {new Date().getFullYear()} {SITE.name}. All rights reserved. For help and support with gambling, visit{' '}
              <a href="https://www.begambleaware.org/" target="_blank" rel="noopener noreferrer nofollow">BeGambleAware</a>,{' '}
              <a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer nofollow">GamCare</a>, or{' '}
              <a href="https://www.gamstop.co.uk/" target="_blank" rel="noopener noreferrer nofollow">GAMSTOP</a>.
            </p>
          </div>
        </div>
      </footer>

      {privacyOpen && <PrivacyModal onClose={() => setPrivacyOpen(false)} />}
      {cookieOpen && <CookieModal onClose={() => setCookieOpen(false)} />}
      {contactOpen && <ContactModal onClose={() => setContactOpen(false)} />}
    </>
  );
}
